import { MoveStruct, normalizeMoveArguments } from "../utils/index.mjs";
import { Balance } from "./balance.mjs";
import { VecSet } from "./vec_set.mjs";
import { TypeName } from "./deps/0x0000000000000000000000000000000000000000000000000000000000000001/type_name.mjs";
import { bcs } from "@safecoin/safe/bcs";
//#region src/contracts/0x2/transfer_policy.ts
/**************************************************************
* THIS FILE IS GENERATED AND SHOULD NOT BE MANUALLY MODIFIED *
**************************************************************/
const $moduleName = "0x2::transfer_policy";
new MoveStruct({
	name: `${$moduleName}::TransferRequest<phantom T0>`,
	fields: {
		item: bcs.Address,
		paid: bcs.u64(),
		from: bcs.Address,
		receipts: VecSet(TypeName)
	}
});
const TransferPolicy = new MoveStruct({
	name: `${$moduleName}::TransferPolicy<phantom T0>`,
	fields: {
		id: bcs.Address,
		balance: Balance,
		rules: VecSet(TypeName)
	}
});
const TransferPolicyCap = new MoveStruct({
	name: `${$moduleName}::TransferPolicyCap<phantom T0>`,
	fields: {
		id: bcs.Address,
		policy_id: bcs.Address
	}
});
new MoveStruct({
	name: `${$moduleName}::TransferPolicyCreated<phantom T0>`,
	fields: { id: bcs.Address }
});
new MoveStruct({
	name: `${$moduleName}::TransferPolicyDestroyed<phantom T0>`,
	fields: { id: bcs.Address }
});
new MoveStruct({
	name: `${$moduleName}::RuleKey<phantom T0>`,
	fields: { dummy_field: bcs.bool() }
});
function _new(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [null];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "transfer_policy",
		function: "new",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function withdraw(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [
		null,
		null,
		"0x1::option::Option<u64>"
	];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "transfer_policy",
		function: "withdraw",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function confirmRequest(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [null, null];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "transfer_policy",
		function: "confirm_request",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
function removeRule(options) {
	const packageAddress = options.package ?? "0x0000000000000000000000000000000000000000000000000000000000000002";
	const argumentsTypes = [null, null];
	return (tx) => tx.moveCall({
		package: packageAddress,
		module: "transfer_policy",
		function: "remove_rule",
		arguments: normalizeMoveArguments(options.arguments, argumentsTypes),
		typeArguments: options.typeArguments
	});
}
//#endregion
export { TransferPolicy, TransferPolicyCap, _new, confirmRequest, removeRule, withdraw };

//# sourceMappingURL=transfer_policy.mjs.map